var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateVariable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6988 31H6.29987C5.95512 31 5.6245 30.8859 5.38072 30.6827C5.13695 30.4795 5 30.204 5 29.9167V6.08333C5 5.79602 5.13695 5.52047 5.38072 5.3173C5.6245 5.11414 5.95512 5 6.29987 5H21.8996L30.9987 12.5833V29.9167C30.9987 30.0589 30.9651 30.1998 30.8998 30.3312C30.8344 30.4627 30.7387 30.5821 30.618 30.6827C30.4973 30.7833 30.354 30.8631 30.1963 30.9175C30.0386 30.972 29.8695 31 29.6988 31Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8996 5V12.5833H31",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1004 21.25H21.8996",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V24.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateVariable);
export default __webpack_public_path__ + "static/media/createVariable.07f7e529.svg";
export { ForwardRef as ReactComponent };